'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

var _STR_INPUT = require('./_constants/STR_INPUT');

var _STR_INPUT2 = _interopRequireDefault(_STR_INPUT);

var _STR_INPUT_LC = require('./_constants/STR_INPUT_LC');

var _STR_INPUT_LC2 = _interopRequireDefault(_STR_INPUT_LC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _alias2.default)(_STR_INPUT_LC2.default, _STR_INPUT2.default); /**
                                                                                * Alias for the input tag. The Input element can be used to define a generic
                                                                                * field within a form for user input.
                                                                                *
                                                                                * @module Input
                                                                                * @func
                                                                                * @since 1.0.0
                                                                                * @param {Object} props
                                                                                */

exports.default = Input;